/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

export default function AutoCompleteSelector({ data, label, onChange, defaultValue }) {
  const [selected, setSelected] = useState(defaultValue.map((v) => v.id) || []);
  const [options, setOptions] = useState(data || []);

  useEffect(() => {
    setOptions((data || []).filter((option) => !selected.includes(option.id)));

    return () => {
      setOptions([]);
    };
  }, [selected]);

  return (
    <Autocomplete
      multiple
      id="autocomplete-selector"
      size="small"
      filterSelectedOptions
      options={options}
      getOptionLabel={(option) => option.title}
      onChange={(e, value) => {
        setSelected(value.map((v) => v.id));
        onChange(value);
      }}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <TextField
          key={params.id}
          {...params}
          style={{ width: '100%' }}
          variant="outlined"
          label={label || 'Selector'}
          // placeholder="Specializations"
        />
      )}
    />
  );
}
